import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from "./App/components/ScrollToTop";
import { AuthProvider } from "./Context/AuthContext";
import AdminUserList from "./App/components/Admin User/AdminUserList";

// Lazy load all pages and layouts
const PublicLayout = lazy(() => import("./App/routes/PublicRoutes"));
const AdminLayout = lazy(() => import("./App/Layouts/AdminLayout"));
const PrivateRoute = lazy(() => import("./App/routes/PrivateRoute"));

const WebsiteHome = lazy(() => import("./App/Website Page/WebsiteHome"));
const WebAbout = lazy(() => import("./App/Website Page/WebAbout"));
const WebBlog = lazy(() => import("./App/Website Page/WebBlog"));
const WebContact = lazy(() => import("./App/Website Page/WebContact"));
const WebBlogDetails = lazy(() => import("./App/Website Page/WebBlogDetails"));
const WebStrategicAdvisory = lazy(() => import("./App/Website Page/WebStrategicAdvisory"));
const WebHumanResourceConsulting = lazy(() => import("./App/Website Page/WebHumanResourceConsulting"));
const WebFinancialConsulting = lazy(() => import("./App/Website Page/WebFinancialConsulting"));
const WebValuationStudies = lazy(() => import("./App/Website Page/WebValuationStudies"));
const WebIdentificationServices = lazy(() => import("./App/Website Page/WebIdentificationServices"));
const WebConsumerResearch = lazy(() => import("./App/Website Page/WebConsumerResearch"));

const AdminDashboard = lazy(() => import("./App/Admin Page/AdminDashboard"));
const AdminEnquery = lazy(() => import("./App/Admin Page/AdminEnquery"));
const AdminBlog = lazy(() => import("./App/Admin Page/AdminBlog"));

const Login = lazy(() => import("./Context/Login"));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <ScrollToTop />
          <Suspense fallback={<div className="text-center p-5">
            <div className="preloader">
          <div id="container">
            <div className="circle"></div>
            <div className="loader1"></div>
            <div className="loader2"></div>
            <div className="loader3"></div>
            <div className="loader4"></div>
          </div>
        </div>
          </div>}>

            <Routes>

              {/* Public Routes */}
              <Route path="/" element={<PublicLayout />}>
                <Route index element={<WebsiteHome />} />
                <Route path="about-us" element={<WebAbout />} />
                <Route path="contact-us" element={<WebContact />} />
              
                <Route path="blogs" element={<WebBlog />} />
                {/* <Route path="blogs-details" element={<WebBlogDetails />} /> */}
                <Route path="blogs/:slug" element={<WebBlogDetails />} />
                <Route path="business-strategy-consulting" element={<WebStrategicAdvisory />} />
                <Route path="hr-consulting-services" element={<WebHumanResourceConsulting />} />
                <Route path="financial-services-consulting" element={<WebFinancialConsulting />} />
                <Route path="business-valuation-service" element={<WebValuationStudies />} />
                <Route path="strategic-partner-identification-services" element={<WebIdentificationServices />} />
                <Route path="consumer-behavior-research-services" element={<WebConsumerResearch />} />
              </Route>

              {/* Login Route */}
              <Route path="/login" element={<Login />} />

              {/* Admin Routes (Private) */}
              <Route path="/admin" element={<PrivateRoute />}>
                <Route element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="users" element={<AdminEnquery />} />
                  <Route path="blog" element={<AdminBlog />} />
                  <Route path="admin-user" element={<AdminUserList />} />
                </Route>
              </Route>

            </Routes>

          </Suspense>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
